var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"preview-template"},[_c('v-card-text',{staticClass:"media-preview-container px-0 py-0"},[_vm._t("media-item")],2),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-flex',[_vm._t("card-actions")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }